module.exports = __webpack_public_path__ + "media/images/flags/cd-f6335ccc7ad85557b78993b10cefc510.svg";